/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetCountryListVariablesDTO = Types.Exact<{
  search?: Types.Maybe<Types.Scalars['String']>;
  paging?: Types.Maybe<Types.PagingDTO>;
}>;


export type GetCountryListDTO = (
  { __typename?: 'Query' }
  & { countries: Array<(
    { __typename?: 'Country' }
    & Pick<Types.CountryDTO, 'id' | 'name'>
  )> }
);


export const GetCountryListDocumentDTO = gql`
    query getCountryList($search: String, $paging: Paging) {
  countries(
    filter: {archived: {equals: false}, name: {contains: $search}}
    paging: $paging
    sort: [{field: "name", order: ASC}]
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetCountryList__
 *
 * To run a query within a React component, call `useGetCountryList` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryList` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryList({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetCountryList(baseOptions?: Apollo.QueryHookOptions<GetCountryListDTO, GetCountryListVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryListDTO, GetCountryListVariablesDTO>(GetCountryListDocumentDTO, options);
      }
export function useGetCountryListLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryListDTO, GetCountryListVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryListDTO, GetCountryListVariablesDTO>(GetCountryListDocumentDTO, options);
        }
export type GetCountryListHookResult = ReturnType<typeof useGetCountryList>;
export type GetCountryListLazyQueryDTOHookResult = ReturnType<typeof useGetCountryListLazyQueryDTO>;
export type GetCountryListQueryResultDTO = Apollo.QueryResult<GetCountryListDTO, GetCountryListVariablesDTO>;